import { Button, Box } from "@mui/material";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import React from "react";
import { useTranslation } from "react-i18next";

export const LogoButton = () => {
  const { t } = useTranslation('general');

  return (
    <Button 
      component={Link} 
      to="/"
      sx={{
        p: 0,
        minWidth: 'auto',
        maxWidth: { xs: '160px', sm: '200px', md: '240px' },
        '&:hover': {
          background: 'none'
        }
      }}
    >
      <Box
        component="img"
        src={logo}
        alt={t('header.logoAlt')}
        sx={{
          height: { xs: '24px', sm: '28px', md: '32px' },
          width: 'auto',
          objectFit: 'contain',
          objectPosition: 'left',
          maxWidth: '100%',
          transition: 'all 0.2s ease'
        }}
      />
    </Button>
  );
};